import React from 'react';
import FontAwesome from 'react-fontawesome';
import MarketplaceProduct from './MarketplaceProduct';
import Api, { Utils } from '../Api';

export default class MarketplaceCollection extends MarketplaceProduct {
  constructor(props) {
    super(props);

    this.imageList = this.imageList.bind(this);
    this.wholesaleInfo = this.wholesaleInfo.bind(this);
    this.extraContent = this.extraContent.bind(this);
    this.displayBrandBlock = this.displayBrandBlock.bind(this);
  }

  displayBrandBlock() {
    let brandList = [];
    let collection = this.state.product;

    collection.items.forEach(
      collectionItem => {
        if (brandList.indexOf(collectionItem.brand_token) < 0) brandList.push(collectionItem.brand_token);
      }
    );

    return brandList.length === 1;
  }

  imageList(product) {
    if (product.image) return [ product.image ];

    return super.imageList(product);
  }

  wholesaleInfo() {
    let collection = this.state.product;

    let wholesalePriceCents = 0;
    let collectionItemCount = 0;
    collection.items.forEach(collectionItem => {
      let product = this.props.productList[collectionItem.product_token];
      let productOption = product.options.find(productOption => { return productOption.token === collectionItem.product_option_token; });
      if (!productOption) {
        console.error('Invalid product option: %s', collectionItem.product_option_token);
        return;
      }

      collectionItemCount += collectionItem.quantity;
      wholesalePriceCents += productOption.wholesale_price_cents * collectionItem.quantity;
    });
    let wholesalePrice = '$' + Utils.formatCents(wholesalePriceCents);

    return {
      wholesale_price: wholesalePrice,
      retail_price: null,
      unit_multiplier: null,
      collection_size: collectionItemCount
    };
  }

  onActiveClick(event) {
    event.preventDefault();

    let collection = this.state.product;
    collection.active = !collection.active;
    return Api.createOrUpdateProductCollection(collection).then(
      () => {
        this.setState({product: collection});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  onManualRecommendationClick(event) {
    event.preventDefault();

    let retailerToken = this.props.retailerToken;
    if (!retailerToken) return;

    let collection = this.state.product;
    let manualRecommendation = collection.manual_recommendation;
    let promise = null;
    if (manualRecommendation) {
      promise = Api.retailerRemoveCollectionRecommendation(retailerToken, collection.token);
    } else {
      promise = Api.retailerAddCollectionRecommendation(retailerToken, collection.token);
    }

    return promise.then(
      () => {
        collection.manual_recommendation = !manualRecommendation;
        this.setState({product: collection});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  extraContent() {
    return <span className="collection-star">Starter Collection <FontAwesome name="star" /></span>;
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/MarketplaceCollection.js
 **/